export enum StockLevel {
    Stock_NotSelected = 0,
    Stock_InStock = 1,
    Stock_LowStock = 2,
    Stock_Enquiries = 3,
    Stock_Unavailable = 4
}
